export default __webpack_public_path__ + "static/media/paso18.843f75f8.png";